<template>
  <div class="section">
    <div class="box">
      <h1 class="title is-1">Device Check for JPCC Devices</h1>
      <p>Jika anda menggunakan device pribadi anda, silahkan klik "Skip"</p>
      <div class="field">
        <label>Apakah anda bertugas pada hari ini?</label>
        <div class="control">
          <label class="radio" v-for="(boolean_row, index) in boolean_list" :key="index">
            <input type="radio" v-model="on_duty" name="on_duty" :value="boolean_row.id"> {{boolean_row.title}}
          </label>
        </div>
        <span class="help is-danger" v-show="errors.has('on_duty')" v-text="errors.first('on_duty')"></span>
      </div>
      <div class="field" v-show="on_duty === 1">
        <label>Service keberapa?</label>
        <div class="control">
          <div class="select">
            <select v-model="service">
              <option value="">Select Service</option>
              <option v-for="(service_row, index) in services_list" :key="index" :value="service_row.id" v-text="service_row.title"></option>
            </select>
          </div>
        </div>
        <span class="help is-danger" v-show="errors.has('service')" v-text="errors.first('service')"></span>
      </div>
      <div class="field">
        <label>Apakah anda menerima device ini dalam keadaan baik dan lengkap?</label>
        <div class="control">
          <label class="radio" v-for="(boolean_row, index) in boolean_list" :key="index">
            <input type="radio" v-model="device_status" name="device_status" :value="boolean_row.id"> {{boolean_row.title}}
          </label>
        </div>
        <span class="help is-danger" v-show="errors.has('device_status')" v-text="errors.first('device_status')"></span>
      </div>
      <div class="field" v-show="device_status === 0">
        <label>Apa yang rusak atau hilang dari device ini? (Jelaskan)</label>
        <div class="control">
          <textarea class="textarea" v-model="device_status_note"></textarea>
        </div>
        <span class="help is-danger" v-show="errors.has('device_status_note')" v-text="errors.first('device_status_note')"></span>
      </div>
      <div class="field is-grouped">
        <div class="control">
          <button type="button" class="button is-link" @click="submitData()">Submit</button>
          <button type="button" class="button is-danger" @click="getModalConfirmation('Device Check', 'Are you sure want to skip this?', 'skip_device_check')">Skip</button>
        </div>
      </div>
    </div>
    <confirmation-modal :data-modal="modal_confirmation_data" @confirm-event="skipDeviceCheck"></confirmation-modal>
  </div>
</template>
<script>
import {ModalConfirmation} from '@/library/mixins/local/ModalConfirmation'
import Fingerprint2 from 'fingerprintjs2'
export default {
  mixins: [ModalConfirmation],
  data () {
    return {
      boolean_list: [
        {
          id: 1,
          title: 'Yes'
        },
        {
          id: 0,
          title: 'No'
        }
      ],
      on_duty: 0,
      services_list: [],
      service: '',
      device_status: 1,
      device_status_note: '',
      fingerprint: '',
      page: 1
    }
  },
  created () {
    var self = this
    self.getServices()
    new Fingerprint2().get(function (result, components) {
      self.fingerprint = result
    })
  },
  methods: {
    getServices () {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      self.flyGet('new_people/get_services')
      .then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          self.services_list = response.data.data
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        self.errorMessage(response)
      })
    },
    submitData () {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      self.flyPostSession('device_status/insert', {
        on_duty: self.on_duty,
        service: self.service,
        device_status: self.device_status,
        device_status_note: self.device_status_note,
        fingerprint: self.fingerprint
      }).then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          self.$geb.emit({id: 'alert_modal', title: 'Thank You!', content: 'Anda dapat melanjutkan pemakaian aplikasi ini.', button_text: 'OK'})
          self.$router.push('/panel/profile')
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      }).catch(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        console.log(response)
      })
    },
    skipDeviceCheck (confirmData) {
      if (confirmData.label === 'skip_device_check') {
        if (confirmData.flag === true) {
          this.$router.push('/panel/profile')
        }
      }

      this.clearModalConfirmationData()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/panel/DeviceCheck.vue